import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { ApiService } from 'src/app/shared/services/api.service';
import { TableColumn, TableAction } from 'src/app/shared/components/data-table/data-table.component';
import { MinutesOfMeetingData } from 'src/app/shared/models/app.models';
import { environment } from 'src/environments/environment';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-minutes-of-meeting',
  templateUrl: './minutes-of-meeting.component.html',
  styleUrls: ['./minutes-of-meeting.component.scss']
})
export class MinutesOfMeetingComponent implements OnInit {
  AppConstants = AppConstants;
  minutesOfMeeting: MinutesOfMeetingData[] = [];
  tableColumns: TableColumn[] = [];

  constructor(
    private _loaderService: LoaderService,
    private apiService: ApiService,
    private _router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.initializeTableColumns();
    this.fetchMinutesOfMeeting();
  }

  private initializeTableColumns(): void {
    const actionIcons: TableAction[] = [
      {
        iconPath: 'assets/icons/eye-icon.svg',
        action: 'view',
        title: 'View'
      },
      {
        iconPath: 'assets/icons/attach.svg',
        action: 'attachment',
        title: 'Attachment'
      },
      {
        iconPath: 'assets/icons/minutes-of-meeting.svg',
        action: 'download',
        title: 'Download'
      }
    ];

    this.tableColumns = [
      {
        field: 'subject',
        header: 'Subject',
        type: 'text'
      },
      {
        field: 'meetingId',
        header: 'Meeting ID',
        type: 'link'
      },
      {
        field: 'momStage',
        header: 'MOM Stage',
        type: 'badge',
        badgeColor: (row: any) => this.getStageColor(row.momStage),
        badgeSize: 'small'
      },
      {
        field: 'actions',
        header: 'Actions',
        type: 'action',
        actions: actionIcons
      }
    ];
  }

  async fetchMinutesOfMeeting(): Promise<void> {
    this._loaderService.showLoader();
    
    try {
      // Only fetch completed meetings (status = 5)
      const url = `${environment.API_URL}/api/Meetings?status=5`;
      const response: any = await lastValueFrom(this.apiService.getByUrl(url));
      
      if (response?.isSuccess && response?.data) {
        // Map backend response to minutes of meeting format
        this.minutesOfMeeting = response.data.map((meeting: any) => {
          return {
            subject: meeting.meetingTitle || meeting.title || '',
            meetingId: meeting.meetingId || '',
            momStage: meeting.momStageName || meeting.mOMStageName || 'Draft',
            id: meeting.id,
            dateTime: meeting.dateTime,
            location: meeting.location,
            status: meeting.status,
            statusName: meeting.statusName
          };
        });
        this.cdr.detectChanges();
      } else {
        console.error('Failed to fetch minutes of meeting:', response?.errorMessageEn);
        this.minutesOfMeeting = [];
        this.cdr.detectChanges();
      }
    } catch (error) {
      console.error('Failed to fetch minutes of meeting:', error);
      this.minutesOfMeeting = [];
      this.cdr.detectChanges();
    } finally {
      this._loaderService.hideLoader();
    }
  }

  uploadMinutes(): void {
    // TODO: Implement upload functionality
    console.log('Upload Minutes of Meeting');
  }

  onTableActionClick(event: {action: string, row: any}): void {
    switch(event.action) {
      case 'view':
        this.viewDetails(event.row.meetingId);
        break;
      case 'attachment':
        this.viewAttachment(event.row);
        break;
      case 'download':
        this.downloadMinutes(event.row);
        break;
    }
  }

  onTableLinkClick(event: {field: string, row: any}): void {
    if (event.field === 'meetingId') {
      this.viewDetails(event.row.meetingId);
    }
  }

  viewDetails(meetingId: string): void {
    this._router.navigate([`/${AppConstants.ROUTES.MINUTES_OF_MEETING}/${AppConstants.ROUTES.MINUTES_OF_MEETING_DETAILS}`, meetingId]);
  }

  viewAttachment(row: any): void {
    // TODO: Open attachment dialog or navigate to attachment view
    console.log('View attachment for:', row.meetingId);
  }

  downloadMinutes(row: any): void {
    // TODO: Implement download minutes of meeting functionality
    console.log('Download minutes for:', row.meetingId);
  }

  getStageColor(stage: string): 'green' | 'blue' | 'pink' | 'gray' | 'yellow' | 'red' | 'orange' | 'purple' {
    switch(stage?.toLowerCase()) {
      case 'completed':
        return 'green';
      case 'pending':
        return 'yellow';
      case 'draft':
        return 'gray';
      default:
        return 'gray';
    }
  }
}

